import en from './en.js';
import fr from './fr.js';
import es from './es.js';
import de from './de.js';
import it from './it.js';
import pt from './pt.js';

export const locales = { en, fr, es, de, it, pt };

/** Builds a translator: locale code or object, plus overrides. Missing keys fall back to English. */
export function createTranslator(locale = 'en', overrides = {}) {
    const base = typeof locale === 'object' && locale ? locale : (locales[String(locale).slice(0, 2).toLowerCase()] || en);
    const strings = { ...en, ...base, ...(overrides || {}) };
    const t = (key, params) => {
        let text = strings[key];
        if (text === undefined) text = key;
        if (params) text = text.replace(/\{(\w+)\}/g, (match, name) => (params[name] !== undefined ? params[name] : match));
        return text;
    };
    t.strings = strings;
    return t;
}

/** Lets a site add or change a language: PageFlow.addLocale('nl', {...}). */
export function addLocale(code, strings) {
    locales[code] = { ...(locales[code] || {}), ...strings };
}
